import React from 'react';

import { ResponsivePicture } from '@/components/ResponsivePicture';
import img1TabImg from '@public/img/adviser/products/find-bdm/img-1-tab.webp';
import img1WebImg from '@public/img/adviser/products/find-bdm/img-1-web.webp';
export const AdviserToolkit = () => {
  return (
    <div id="adviser-toolkit" className="container mx-auto scroll-mt-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-16 xl:gap-20">
        <div className="hidden md:block order-1 md:order-last lg:order-first md:pt-6 lg:pt-0">
          <ResponsivePicture
            mobile={img1TabImg}
            tablet={img1TabImg}
            desktop={img1WebImg}
            alt="Adviser using marketing toolkit resources to connect with clients"
            sizes="(min-width: 1024px) 50vw, calc(100vw - 3rem)"
            className="block w-full rounded-xl"
            pictureClassName="block w-full"
          />
        </div>

        <div className="order-2 md:order-first lg:order-last lg:flex lg:items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl font-semibold text-[#0C0D1A] pb-8 md:pb-10 w-full md:w-[34rem] lg:w-auto">
              Here&apos;s how our adviser toolkit can support <span className="text-[#006EB7]">advisers like you</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-8 md:gap-10">
              <div className="flex flex-col lg:flex-row items-start gap-4">
                <div className="flex-shrink-0">
                  <img src="/img/icons/message-text-square-02.svg" alt="Connect" className="w-6 h-6" />
                </div>
                <p className="text-[#0C0D1A] text-base font-semibold">
                  Connect with new or existing clients.
                  <span className="text-[#373945] font-450"> Highlight what makes you different from competitors and make a real connection with your audience.</span>
                </p>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-4">
                <div className="flex-shrink-0">
                  <img src="/img/icons/presentation-chart-01.svg" alt="Promote" className="w-6 h-6" />
                </div>
                <p className="text-[#0C0D1A] text-base font-semibold">
                  Promote your business at events.
                  <span className="text-[#373945] font-450"> Streamline your promotional efforts whether you&#39;re representing your business in person or online.</span>
                </p>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-4">
                <div className="flex-shrink-0">
                  <img src="/img/icons/book-open-01.svg" alt="Educate" className="w-6 h-6" />
                </div>
                <p className="text-[#0C0D1A] text-base font-semibold">
                  Educate others on lifetime mortgages.
                  <span className="text-[#373945] font-450"> Become a thought leader in your industry and use our toolkit to share trends and insights with peers.</span>
                </p>
              </div>

              <div className="flex flex-col lg:flex-row items-start gap-4">
                <div className="flex-shrink-0">
                  <img src="/img/icons/bar-chart-12.svg" alt="Opportunities" className="w-6 h-6" />
                </div>
                <p className="text-[#0C0D1A] text-base font-semibold">
                  Create new business opportunities and encourage referrals.
                  <span className="text-[#373945] font-450"> Use our marketing toolkit resources to generate new leads for your business.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="text-base text-center text-[#373945] pt-8 font-medium md:w-[35rem] lg:w-full mx-auto">
        For questions or support, <a
          href="/professionals/resources/adviser-support-tools/equity-release-faqs/marketing-toolkit-questions"
          className="plain-text-link--grey plain-text-link--underline">
        please explore our marketing toolkit FAQs.
        </a>
      </p>
    </div>
  );
};
